import axios from 'axios';

export const api = {
  hostname: `${import.meta.env.VITE_API_URL}`,
};

export const filesApi = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}`,
});
